export default __webpack_public_path__ + "static/media/funtel-logo.b86703ec.png";